export const Grain = () => <div className="grain-overlay" aria-hidden="true" />;
